import { render, staticRenderFns } from "./CustomersController.vue?vue&type=template&id=3ab9cb10"
import script from "./CustomersController.vue?vue&type=script&lang=js"
export * from "./CustomersController.vue?vue&type=script&lang=js"
import style0 from "./CustomersController.vue?vue&type=style&index=0&id=3ab9cb10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports